import { ColumnDef } from "@tanstack/react-table";
import { DashboardRankingsUser } from "../../types";

interface DashboardRankingsUsersColumnsProps<TData> {
  translations: Record<string, string>;
}

export function DashboardRankingsUsersColumns({
  translations,
}: DashboardRankingsUsersColumnsProps<DashboardRankingsUser>): ColumnDef<DashboardRankingsUser>[] {
  return [
    {
      accessorKey: "position",
      header: translations.position,
      cell: (info) => `${info.getValue()}º`,
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: translations.name,
      cell: (info) => info.getValue(),
      enableSorting: false,
    },
    {
      accessorKey: "email",
      header: translations.email,
      cell: (info) => info.getValue(),
      enableSorting: false,
    },
    {
      accessorKey: "value",
      header: translations.value,
      cell: (info) => info.getValue(),
      enableSorting: false,
    },
  ];
}
